(ns app.front.view.admin.gis.i18n-mapping-config
  (:require [app.front.entities :as entities]
            [app.front.ui :as ui]
            [app.front.ui.section :as section]
            [app.front.ui.select :as ui-select]
            [app.front.util :refer [for-frag for-frag-indexed]]
            [app.front.view.admin.common :as admin-common]
            [app.gis.config-model :as gis-config-model]
            [clojure.set :as set]
            [clojure.string :as str]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.front.icons :as i]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]
            [reagent.core :as r]))


(rf/reg-sub ::groups-with-mappings
  :<- [::admin-common/domain-groups-for-translation-mappings]
  (fn [groups _]
    (filter :group/property-i18n-mapping groups)))


(rf/reg-sub ::virtual-mapping-configs
  :<- [::groups-with-mappings]
  (fn [groups _]
    (->> groups
         (reduce (fn [acc {:keys [:group/property-i18n-mapping] :as group}]
                   (update acc property-i18n-mapping (comp set conj) group))
                 {})
         (map (fn [[mapping groups]]
                (let [names (->> groups
                                 (map :group/name)
                                 sort)]
                  {:config      {:group/property-i18n-mapping mapping
                                 :group-ids                   (set (map :db/id groups))}
                   :group-names names
                   :title       (str (->> names
                                          (take 3)
                                          (str/join ", "))
                                     (when (> (count groups) 3)
                                       " et al."))})))
         (sort-by :title))))






(rf/reg-event-fx ::save-mapping
  (fn [{:keys [db]} [_ data *editor-open?]]
    {:db           (assoc db ::save-in-progress? true)
     :comm/command {:command          :admin/save-property-i18n-mapping
                    :method           :post
                    :data             data
                    :notify           {:success :gis-editor/config-saved}
                    :on-success       [::save-mapping.success *editor-open?]
                    :finally-dispatch [::save-mapping.done]}}))


(rf/reg-event-fx ::remove-mapping
  (fn [{:keys [db]} [_ group-ids]]
    {:db           (assoc db ::save-in-progress? true)
     :comm/command {:command          :admin/remove-property-i18n-mapping
                    :method           :post
                    :data             {:group-ids group-ids}
                    :notify           {:success :gis-editor/remove-success}
                    :on-success       [::entities/apply-changes]
                    :finally-dispatch [::save-mapping.done]}}))


(rf/reg-event-fx ::save-mapping.success
  (fn [_ [_ *editor-open? status changes]]
    (reset! *editor-open? false)
    {:dispatch [::entities/apply-changes status changes]}))


(rf/reg-event-db ::save-mapping.done
  (fn [db _]
    (assoc db ::save-in-progress? false)))


(rf/reg-sub ::save-in-progress? :-> ::save-in-progress?)


(defn mapping-editor [tr original-config *open?]
  (r/with-let [*config (r/atom original-config)]
    (let [domain-groups   (<sub [::admin-common/domain-groups-for-translation-mappings])
          i18n-mapping    (:group/property-i18n-mapping @*config {})
          invalid-config? (or (empty? i18n-mapping)
                              (empty? (:group-ids @*config))
                              (= @*config original-config))]
      [:section.bg-ui-light-gray.rounded
       [:div.w-full.lg:w-1-2
        [:h5.mb-2 (tr [:gis-editor/groups-using-config])]
        [admin-common/member-group-editor {:tr                tr
                                           :groups            domain-groups
                                           :current-group-ids (:group-ids @*config)
                                           :light             true
                                           :add-title         (tr [:gis-editor/add-group])
                                           :save-fn           #(swap! *config update :group-ids (comp set conj) %)
                                           :remove-fn         #(swap! *config update :group-ids disj %)}]]
       [:div.mt-6
        [:h5.mb-2 (tr [:gis-property-i18n-config/translation-mapping])]
        [:table
         [:thead
          [:tr.font-semibold
           [:th.pr-4.py-2.text-left (tr [:gis-property-i18n-config/property-attribute])]
           [:th.pr-4.py-2.text-left (tr [:gis-property-i18n-config/ui-default])]
           [:th.py-2.text-left (tr [:gis-property-i18n-config/ui-override])]]]
         (into
           [:tbody]
           (for [attr gis-config-model/i18n-overridable-keys
                 :let [id (str/join "-" ["mapping" attr])]]
             [:tr
              [:td.pr-4.py-1.align-middle
               [:label {:for id}
                (tr [(keyword "property-gis-admin" (name attr))])]]
              [:td.pr-4.py-1.align-middle
               (tr [attr])]
              [:td.py-1
               [ui-select/select {:id           id
                                  :class-name   "full-width-select"
                                  :light        true
                                  :select-text  (tr [:gis-editor/select-attribute])
                                  :label-text   (tr [:gis-editor/gis-attribute])
                                  :hide-label   true
                                  :value        (attr i18n-mapping)
                                  :on-change    #(swap! *config assoc-in [:group/property-i18n-mapping attr] %)
                                  :val->str     #(tr [%])
                                  :allow-empty? true
                                  :values       gis-config-model/i18n-override-values}]]]))]]
       [:div.flex.justify-end.mt-6
        (when-not (empty? original-config)
          [ui/modal-confirmation-button {:tr                  tr
                                         :trigger-button-text (tr [:remove])
                                         :trigger-button-opts {:kind       :danger
                                                               :class-name "mr-2"}
                                         :on-yes-click        #(>evt [::remove-mapping
                                                                      (:group-ids original-config)])}
           (tr [:gis-property-i18n-config/confirm-removal])])
        (cc/button {:kind       :ghost
                    :class-name "mr-2"
                    :on-click   #(reset! *open? false)}
                   (tr [:cancel]))
        (cc/button {:disabled (boolean (or invalid-config?
                                           (<sub [::save-in-progress?])))
                    :on-click #(>evt [::save-mapping
                                      (p/assoc-if @*config
                                                  :removed-group-ids (set/difference (:group-ids original-config)
                                                                                     (:group-ids @*config)))
                                      *open?])}
                   (tr [:save]))]])))


(defn existing-mapping-view [tr idx {:keys [title config group-names]}]
  (r/with-let [*editing? (r/atom false)]
    (if @*editing?
      [mapping-editor tr config *editing?]
      [section/section
       (str idx "-config-section")
       {:tr             tr
        :class          "bg-ui-light-gray rounded"
        :heading-button (cc/button {:size             :small
                                    :kind             :ghost
                                    :icon-description ""
                                    :on-click         #(reset! *editing? true)}
                                   (tr [:edit]))}
       title
       [:div
        [:h6.mb-2 (tr [:gis-editor/groups-using-config])]
        [:div.flex.flex-wrap
         [:div
          (for-frag [group-name group-names]
            [ui/tag {:type       :round
                     :color      :night-sky
                     :class-name "first:ml-0 cloudpermit--tag--round"}
             group-name])]]
        [:div.flex.flex-wrap
         (for-frag [[k v] (:group/property-i18n-mapping config)]
           [:div.mt-3.pr-6
            [:div.bx--label
             (tr [(keyword "property-gis-admin" (name k))])]
            [:div (tr [v])]])]]])))


(defn mapping-list [tr]
  (r/with-let [*new-open? (r/atom false)]
    (let [mappings (<sub [::virtual-mapping-configs])]
      [section/section
       :mapping-configs
       {:tr                   tr
        :initially-collapsed? true}
       (tr [:gis-property-i18n-config/title])
       [:div.flex.justify-end.items-center
        (cc/button {:icon     i/plus
                    :on-click #(reset! *new-open? true)}
                   (tr [:gis-property-i18n-config/add]))]
       (when @*new-open?
         [mapping-editor tr {} *new-open?])
       (for-frag-indexed [[i mapping] mappings]
         [existing-mapping-view tr i mapping])])))
